import axios, { Method, AxiosRequestHeaders } from 'axios';

export const fetch = (endpoint: string,
                      method: Method,
                      data: Record<string, unknown> | FormData = {},
                      secure: boolean | undefined = false,
                      extraAxiosOptions: any = {}) => {
    const baseUrl: string = process.env.REACT_APP_PARISDBCONVERSION_API_URL;
    const headers: AxiosRequestHeaders = {};

    if (secure) {
        const token = window.localStorage.getItem('token');

        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
    }
 
    return axios({
        url: baseUrl + endpoint,
        method,
        data,
        headers,
        ...extraAxiosOptions
    });
};
